import Vue from 'vue'
import App from './App.vue'
import Axios from 'axios'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueSmoothScroll from 'vue2-smooth-scroll'
// import VueRouter from 'vue-router'
import './session'
import router from './router'
import '../src/scss/main.scss'

// import VueSession from 'vue-session'
import CKEditor from '@ckeditor/ckeditor5-vue';
import IdleVue from "idle-vue";
import ImageUploader from 'vue-image-upload-resize'
Vue.use(ImageUploader);
// import '@/css/main.scss'
// import '../src/css/main.scss'
// import store from './store';

const eventsHub = new Vue();

Vue.use( CKEditor );
Vue.use(VueSmoothScroll)
Vue.prototype.$http = Axios;
Vue.config.productionTip = false
Vue.use(Buefy)
// import '@/css/main.scss'
// Vue.use(VueRouter)
//  Vue.prototype.$apiUrl = 'http://gerpanapi.sayangkucing.xyz/api/';
// Vue.prototype.$apiUrl = 'http://127.0.0.1:8000/api/';
Vue.prototype.$apiUrl = 'https://api-pandai.bebras.or.id/api/';


// const router = new VueRouter({
//   linkActiveClass: 'is-active',
//   routes: Routes,
//   mode: 'history'
// })
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   store,
//   idleTime: 3000, // 3 seconds
//   startAtIdle: false
// });

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
